import { Tag } from "@chakra-ui/react";
import styles from "./index.module.css";
export const CustomTag = (props) => {
  return (
    <Tag className={styles.tag} {...props}>
      {props.children}
    </Tag>
  );
};
